import React, { Component } from "react";
import Styled from "./style";
// import { withRouter } from "react-router";
import CashVoucher from "./CashVoucher";
import DiscountVoucher from "./DiscountVoucher";
import FoodVoucher from "./FoodVoucher";
import VoucherCarousel from "./VoucherCarousel";

class VoucherComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  _render = () => {
    let comp = null;
    switch (this.props.type) {
      case "V":
        comp = <CashVoucher {...this.props} />;
        break;
      case "C":
        comp = <FoodVoucher {...this.props} />;
        break;
      case "D":
        comp = <DiscountVoucher {...this.props} />;
        break;
      case "VC":
        comp = <VoucherCarousel {...this.props} />;
        break;
      default:
        comp = <div></div>;
        break;
    }
    return comp;
  };

  render() {
    return <Styled>{this._render()}</Styled>;
  }
}

export default VoucherComponent;
